export interface Screens {
	screenS: string;
	screenGTS: string;
	screenM: string;
	screenL: string;
}

const size = {
	mobileMin: 360,
	tabletMin: 768,
	desktopMin: 1280,
};

const screens = {
	screenS: `only screen and (max-width: ${size.tabletMin}px)`,
	screenGTS: `only screen and (min-width: ${size.tabletMin}px)`,
	screenM: `only screen and (min-width: ${size.tabletMin}px) and (max-width: ${size.desktopMin}px)`,
	screenL: `only screen and (min-width: ${size.desktopMin}px)`,
};

const percentageDeviceHeight = (percent: number) => {
	const vhValue = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--vh') || '1');
	const actualHeight = vhValue * 100;
	return actualHeight * (percent / 100);
};

const isMobile = () => window.matchMedia(`(max-width: ${size.tabletMin})`).matches;
const isTablet = () => window.matchMedia(`(max-width: ${size.desktopMin})`).matches;
const isDesktop = () => window.matchMedia(`(min-width: ${size.desktopMin})`).matches;
const isMobileOrTablet = () => isMobile() || isTablet();

export {
	isDesktop,
	isMobile,
	isMobileOrTablet,
	isTablet,
	percentageDeviceHeight,
	screens,
	size
};
